// src/api/authApi.js

//export const API_BASE_URL = "http://localhost:8080/v1/r2r/auth";
export const API_BASE_URL = "https://ready2rental.onrender.com/v1/r2r/auth";
/**
 * 🔥 Login API
 * This is the ONLY API you need.
 * It handles:
 *  - new user creation
 *  - existing user login
 *  - multi-role support (partner, customer, employee, admin)
 */
export const loginWithFirebase = async (idToken,role) => {
  try {
    const response = await fetch(`${API_BASE_URL}/login?role=${role}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + idToken,

      }
   
    });

    if (!response.ok) {
    const txt = await response.text();
    throw new Error(txt || "Login failed");
  }
  return response.json();
  } catch (error) {
    console.error("❌ Login API Error:", error);
    throw error;
  }
};
